




import {Component, Vue} from 'vue-property-decorator';
import { Action, Mutation } from 'vuex-class';
import {MutationTypes as UserMutationTypes} from "@/store/user/types";
import {User} from "@/models/User";
import UserService from "@/services/UserService";
import TokenService from '../../services/TokenService';
import {ActionTypes as ActionTypesQueue} from '../../store/queues/types';

const queueNamespace: string = 'queue';
const userNamespace = 'user';

@Component
export default class PostAuth extends Vue {
  @Mutation(UserMutationTypes.SET_LOGGED_USER, {namespace: userNamespace}) setLoggedUser!: (payload: User | null) => void;
  @Action(ActionTypesQueue.FETCH_USER_QUEUES, {namespace: queueNamespace}) fetchUserQueues!: (user: User) => Promise<void>;

  private async mounted(): Promise<void> {
    if (Object.keys(this.$route.query).length) {
      const accessToken: string = this.$route.query.accessToken.toString();
      const refreshToken: string = this.$route.query.refreshToken.toString();

      if (accessToken !== '' && refreshToken !== '') {
        TokenService.setToken({accessToken, refreshToken});
        const user = await UserService.fetchUserData();
        this.setLoggedUser(user);
        await this.fetchUserQueues(user);
        if (this.$route.path !== '/app') {
          this.$router.push('/app');
        }
      }
    } else if (this.$route.path !== '/login') {
      this.$router.push('/login');
    }
  }
}
